module.exports = __webpack_public_path__ + "img/94f6c60.jpg";